// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"ChangeProductStatusConfirmPopup_confirmButton__244v7","declineButton":"ChangeProductStatusConfirmPopup_declineButton__1PbGq"};